export default "<p>\n  editor works!\n</p>"